import { render } from "./RewardDetail.vue?vue&type=template&id=526c85a0&scoped=true"
import script from "./RewardDetail.vue?vue&type=script&lang=js"
export * from "./RewardDetail.vue?vue&type=script&lang=js"

import "./RewardDetail.vue?vue&type=style&index=0&id=526c85a0&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526c85a0"]])

export default __exports__